import { useMediaQuery } from '../../../hooks/useMediaQuery';
import NameModalDesktop from './NameModalDesktop';
import NameModalMobile from './NameModalMobile';

interface NameModalProps {
  onSubmit: (firstName: string, lastName: string) => void | Promise<void>;
  onClose: () => void;
}

const NameModal = ({ onSubmit, onClose }: NameModalProps) => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) {
    return <NameModalDesktop onSubmit={onSubmit} onClose={onClose} />;
  }

  return <NameModalMobile onSubmit={onSubmit} onClose={onClose} />;
};

export default NameModal;
